import React, { useState, useEffect } from "react";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import Select from "react-select";
import moment from "moment";
import CustomDatePicker from "../../../../components/Custom-Datepicker";
import { FaSpinner } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as Yup from "yup";

const AddAssetForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Add Asset"));
  }, []);
  const initialFormData = {
    Name: "",
    Description: "",
    ItemType_001: null,
    Brand_1158: null,
    Model_1159: null,
    CategoryID_1160: null,
    IsDiscontinued: null,
    IsVariantRequired: null,
    InvoiceNumber: null,
    AssetType: null,
    Allocated: null,
    PurchaseDate: "",
    VendorID: null,
    BatchNo: "",
    WarrantyDate: "",
    AssetPrice: "",
    PaymentMethod: "",
    PaymentDate: "",
    TransactionNo: "",
    SubscriptionStartDate: "",
    SubscriptionEndDate: "",
    Storage: "",
    Memory: "",
    Processor: "",
  };

  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [assetTypeOption, setAssetTypeOption] = useState([]);
  const [allocatedOption, setAllocatedOption] = useState([]);
  const [categoryTypeOption, setCategoryTypeOption] = useState([]);
  const [brandOption, setBrandOption] = useState([]);
  const [modelOption, setModelOption] = useState([]);
  const [vendorOption, SetVendorOption] = useState([]);
  const [statusOption, setStatusOPton] = useState([]);
  const [assetname, setAssetName] = useState("");
  const [invoiceNumberOption, SetInvoiceNumberOption] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);
  const [paymentOption, setPaymentMoethodOption] = useState([]);

  useEffect(() => {
    fetchGetAddAsset();
  }, []);

  const fetchGetAddAsset = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}asset?P_AssetType=0&P_CategoryID_1160=0&P_Allocated=0`
      );
      if (response.status === 200) {
        const cleanedData = response?.data;
        setPageLoading(false);
        const assetList = Object.entries(response?.data?.assetType || {}).map(
          ([key, value]) => ({
            value: parseInt(key, 10), // Convert key to a number
            label: value,
          })
        );

        setAssetTypeOption(assetList);
        const allocated = Object.entries(
          response?.data?.allocatedType || {}
        ).map(([key, value]) => ({
          value: parseInt(key, 10), // Convert key to a number
          label: value,
        }));

        setAllocatedOption(allocated);
        const payMeth = Object.entries(response?.data?.paymentMethod || {}).map(
          ([key, value]) => ({
            value: key, // Convert key to a number
            label: value,
          })
        );

        setPaymentMoethodOption(payMeth);

        const vendorList = response?.data?.vendorList?.map((ele, index) => ({
          value: ele?.value,
          label: ele?.text,
        }));
        SetVendorOption(vendorList);
        const invoiceList = response?.data?.invoiceList?.map((ele, index) => ({
          value: ele?.value,
          label: ele?.text,
        }));
        SetInvoiceNumberOption(invoiceList);

        setLoading(false);
      } else {
        console.error(
          "Failed to fetch Vendor Master. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Vendor Master:", error);
    }
  };

  useEffect(() => {
    setFormData((prevData) => ({ ...prevData, CategoryID_1160: null }));
    if (formData.AssetType !== undefined && formData.AssetType !== null) {
      setCategoryTypeOption([]); // Clear category options while fetching new data
      fetchGetCategoryDetails(formData.AssetType);
    }
  }, [formData.AssetType]); // Trigger only when AssetType changes

  useEffect(() => {
    setFormData((prevData) => ({ ...prevData, Brand_1158: null }));
    if (
      formData.CategoryID_1160 !== undefined &&
      formData.CategoryID_1160 !== null
    ) {
      setBrandOption([]); // Clear brand options while fetching new data
      fetchGetBrandDetails(formData.CategoryID_1160);
    }
  }, [formData.CategoryID_1160]); // Trigger only when CategoryID_1160 changes

  const fetchGetCategoryDetails = async (id) => {
    setFormData((prevData) => ({ ...prevData, CategoryID_1160: null }));

    try {
      const queryParams = new URLSearchParams({
        AssetType: id,
      });
      const response = await GetServiceCaller(
        `${API_URL}get-asset-categories?${queryParams.toString()}`
      );
      if (response.status === 200) {
        const fetchData = response?.data?.data;
        const categoryList = fetchData?.map((ele, index) => ({
          value: ele?.ID,
          label: ele?.CategoryName,
        }));

        setCategoryTypeOption(categoryList);

        setLoading(false);
      } else {
        console.error(
          "Failed to fetch model masters. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("An error occurred while fetching brand details:", error);
    }
  };

  const fetchGetBrandDetails = async (id) => {
    try {
      const queryParams = new URLSearchParams({
        CategoryID: id,
      });
      const response = await GetServiceCaller(
        `${API_URL}get-brands?${queryParams.toString()}`
      );
      setAssetName("");
      if (response.status === 200) {
        const fetchData = response?.data?.data;
        const data = response?.data;
        // Safely access the AssetCode from the first item in the getCategory array
        // const code =  ?? null; // Use nullish coalescing for a fallback value
        // setAssetName()
        setFormData({
          ...formData,
          Name: `${data?.assetName}`,
        });
        const brandList = fetchData?.map((ele, index) => ({
          value: ele?.ID,
          label: ele?.Brand,
        }));

        setBrandOption(brandList);

        setLoading(false);
      } else {
        console.error(
          "Failed to fetch model masters. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("An error occurred while fetching brand details:", error);
    }
  };

  useEffect(() => {
    setFormData((prevData) => ({ ...prevData, Model_1159: null }));

    if (formData.Brand_1158 !== undefined && formData.Brand_1158 !== null) {
      fetchGetModelDetails(formData.Brand_1158);
      setModelOption([]); // Clear category options while fetching new data
    }
  }, [formData.Brand_1158]);

  const fetchGetModelDetails = async (id) => {
    try {
      const queryParams = new URLSearchParams({
        BrandID: id,
      });
      const response = await GetServiceCaller(
        `${API_URL}get-models?${queryParams.toString()}`
      );
      if (response.status === 200) {
        const fetchData = response?.data?.data;
        const data = response?.data;
        // Safely access the AssetCode from the first item in the getCategory array
        const code = data?.getCategory?.[0]?.AssetCode ?? null; // Use nullish coalescing for a fallback value
        // setAssetName(code)
        // console.log("AssetCode:", code);
        const modelList = fetchData?.map((ele, index) => ({
          value: ele?.ID,
          label: ele?.Model,
        }));

        setModelOption(modelList);

        setLoading(false);
      } else {
        console.error(
          "Failed to fetch model masters. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("An error occurred while fetching brand details:", error);
    }
  };

  const schema = Yup.object().shape({
    AssetPrice: Yup.string().required("Price is Required"),
    Model_1159: Yup.number().nullable(),
    CategoryID_1160: Yup.number().required("Category is Required"),
    Brand_1158: Yup.number().nullable(),
    AssetType: Yup.number().required("Asset Type is Required"),
    Allocated: Yup.string().required("Status is Required"),
    PurchaseDate: Yup.string().required("Purchase Date is Required"),
  });

  const validateField = async (fieldName, updatedData) => {
    try {
      // Validate the specific field
      await schema.validateAt(fieldName, updatedData);

      // Clear the error for the specific field if validation is successful
      setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: "" }));
    } catch (err) {
      if (err.path === fieldName) {
        // Update the error only for the specific field
        setErrors((prevErrors) => ({
          ...prevErrors,
          [fieldName]: err.message,
        }));

        // Show error using toast for specific fields if needed
        if (fieldName.startsWith("lines")) {
          toast.error(err.message, { position: "top-right" });
        }
      } else {
        console.error("Validation error structure is not as expected:", err);
      }
    }
  };

  const handleSelect = async (selectedOption, name) => {
    // Update formData with the selected value for the SkillID
    setFormData((prevData) => {
      const updatedData = { ...prevData, [name]: selectedOption.value };
      // Trigger validation for the specific field after updating
      validateField(name, updatedData);
      return updatedData;
    });
  };
  const handleInvoiceSelect = async (selectedOption, name) => {
    setFormData((prevData) => {
      const updatedData = { ...prevData, [name]: selectedOption.label };
      // Trigger validation for the specific field after updating
      validateField(name, updatedData);
      return updatedData;
    });
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormData((prevState) => {
      const updatedData = { ...prevState, [name]: value };
      // Trigger validation for the specific field after updating
      validateField(name, updatedData); // Validate this field on change
      return updatedData;
    });
  };

  //   const handleSubmit = async (e) => {
  //     e.preventDefault();
  //     setLoading(true);
  //     console.log("Submitting Form Data:", formData);

  //     try {
  //       // Validate the entire form, capturing all errors
  //       await schema.validate(formData, { abortEarly: false });

  //       // If validation passes, clear errors
  //       setErrors({});

  //       // Proceed with API call
  //       const response = await PostServiceCaller(
  //         `${API_URL}asset`,
  //         {
  //           ...formData,
  //           PurchaseDate:
  //             (formData?.PurchaseDate &&
  //               moment(formData?.PurchaseDate).format("YYYY-MM-DD")) ||
  //             "",
  //           WarrantyDate:
  //             (formData?.WarrantyDate &&
  //               moment(formData?.WarrantyDate).format("YYYY-MM-DD")) ||
  //             "",
  //         },
  //         "post"
  //       );

  //       if (response.status === 200) {
  //         toast.success("Data submitted successfully");
  //         // Redirect after a successful submission
  //         setTimeout(() => {
  //           navigate(`/add-asset`);
  //         }, 2000);
  //       } else {
  //         console.error(
  //           "Failed to submit data. Server responded with status:",
  //           response.status
  //         );
  //       }
  //     } catch (error) {
  //       // Handle form validation errors
  //       if (error instanceof Yup.ValidationError) {
  //         // Update error state for all fields with validation errors
  //         const errorMessages = error.inner.reduce((acc, curr) => {
  //           acc[curr.path] = curr.message;
  //           return acc;
  //         }, {});

  //         // Set the error state
  //         setErrors(errorMessages);

  //         console.error("Validation errors:", errorMessages);
  //       } else {
  //         console.error("Unexpected Error:", error);
  //       }
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
 
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Validate the entire form, capturing all errors
      await schema.validate(formData, { abortEarly: false });

      // If validation passes, clear errors
      setErrors({});

      // Prepare payload based on AssetType selection
      let additionalFields = {};
      if (formData.AssetType === 1) {
        // AssetType "1" (Software) - Include Subscription Dates
        additionalFields = {
          SubscriptionStartDate:
            formData?.SubscriptionStartDate &&
            moment(formData?.SubscriptionStartDate).format("YYYY-MM-DD"),
          SubscriptionEndDate:
            formData?.SubscriptionEndDate &&
            moment(formData?.SubscriptionEndDate).format("YYYY-MM-DD"),
        };
      } else if (formData.AssetType === 0) {
        // AssetType "0" (Hardware) - Include Storage, Memory, and Processor
        additionalFields = {
          Storage: formData?.Storage || "",
          Memory: formData?.Memory || "",
          Processor: formData?.Processor || "",
        };
      }

      // Proceed with API call
      const response = await PostServiceCaller(
        `${API_URL}asset`,
        {
          ...formData,
          ...additionalFields, // Include extra fields based on AssetType
          PurchaseDate:
            (formData?.PurchaseDate &&
              moment(formData?.PurchaseDate).format("YYYY-MM-DD")) ||
            "",
          WarrantyDate:
            (formData?.WarrantyDate &&
              moment(formData?.WarrantyDate).format("YYYY-MM-DD")) ||
            "",
        },
        "post"
      );

      if (response.status === 200) {
        toast.success("Data submitted successfully");
        // Redirect after a successful submission
        setTimeout(() => {
          navigate(`/add-asset`);
        }, 2000);
      } else {
        console.error(
          "Failed to submit data. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      // Handle form validation errors
      if (error instanceof Yup.ValidationError) {
        // Update error state for all fields with validation errors
        const errorMessages = error.inner.reduce((acc, curr) => {
          acc[curr.path] = curr.message;
          return acc;
        }, {});

        // Set the error state
        setErrors(errorMessages);

        console.error("Validation errors:", errorMessages);
      } else {
        console.error("Unexpected Error:", error);
      }
    } finally {
      setLoading(false);
    }
  };

  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <>
        <div className="Container">
              <form
                id="formOne"
                className="rounded mt-2 bg-white"
                onSubmit={handleSubmit}
              >
                <div class="card-body  mx-2">
                  <div className="row">
                    <div className="col-md-3">
                      <label class="form-label">
                        Asset Type<span className="text-danger">*</span>
                      </label>
                      <Select
                        name="AssetType"
                        onChange={(selectedOption, action) =>
                          handleSelect(selectedOption, action.name)
                        }
                        value={assetTypeOption?.find(
                          (o) => o.value === formData?.AssetType
                        )}
                        className={` ${errors.AssetType ? "is-invalid" : ""}`}
                        options={[
                          { value: null, label: "Select" },
                          ...assetTypeOption,
                        ]}
                      />
                      {errors.AssetType && (
                        <div className="invalid-feedback">
                          {errors.AssetType}
                        </div>
                      )}
                    </div>
                    <div className="col-md-3">
                      <label class="form-label">
                        Category<span className="text-danger">*</span>
                      </label>
                      <Select
                        name="CategoryID_1160"
                        onChange={(selectedOption, action) =>
                          handleSelect(selectedOption, action.name)
                        }
                        value={
                          categoryTypeOption?.find(
                            (o) => o.value === formData?.CategoryID_1160
                          ) || null
                        }
                        className={` ${
                          errors.CategoryID_1160 ? "is-invalid" : ""
                        }`}
                        options={[
                          { value: null, label: "Select" },
                          ...categoryTypeOption,
                        ]}
                      />
                      {errors.CategoryID_1160 && (
                        <div className="invalid-feedback">
                          {errors.CategoryID_1160}
                        </div>
                      )}
                    </div>
                    <div className="col-md-3">
                      <label class="form-label">Asset Name</label>
                      <input
                        name="Name"
                        type="text"
                        value={formData?.Name}
                        className="form-control"
                        disabled
                        readOnly
                      />
                    </div>
                    <div className="col-md-3">
                      <label class="form-label">Make</label>
                      <Select
                        name="Brand_1158"
                        onChange={(selectedOption, action) =>
                          handleSelect(selectedOption, action.name)
                        }
                        value={
                          brandOption?.find(
                            (o) => o.value === formData?.Brand_1158
                          ) || null
                        }
                        options={[
                          { value: null, label: "Select" },
                          ...brandOption,
                        ]}
                        className={` ${errors.Brand_1158 ? "is-invalid" : ""}`}
                      />
                      {errors.Brand_1158 && (
                        <div className="invalid-feedback">
                          {errors.Brand_1158}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-md-3">
                      <label class="form-label">Model</label>
                      <Select
                        name="Model_1159"
                        onChange={(selectedOption, action) =>
                          handleSelect(selectedOption, action.name)
                        }
                        value={
                          modelOption?.find(
                            (o) => o.value === formData?.Model_1159
                          ) || null
                        }
                        className={` ${errors.Model_1159 ? "is-invalid" : ""}`}
                        options={[
                          { value: null, label: "Select" },
                          ...modelOption,
                        ]}
                      />
                      {errors.Model_1159 && (
                        <div className="invalid-feedback">
                          {errors.Model_1159}
                        </div>
                      )}
                    </div>
                    <div className="col-md-3">
                      <label class="form-label">
                        Purchase Date<span className="text-danger">*</span>
                      </label>
                      <CustomDatePicker
                        // handleChange={(e) => handleReqDate(e)}
                        handleChange={(e) => handleChange(e)}
                        value={formData.PurchaseDate}
                        name="PurchaseDate"
                        className={`form-control ${
                          errors.PurchaseDate ? "is-invalid" : ""
                        }`}
                        placeholderText="DD-MM-YYYY"
                      />
                      {errors.PurchaseDate && (
                        <div className="text-danger">{errors.PurchaseDate}</div>
                      )}
                    </div>
                    <div className="col-md-3">
                      <label class="form-label">Vendor</label>
                      <Select
                        name="VendorID"
                        onChange={(selectedOption, action) =>
                          handleSelect(selectedOption, action.name)
                        }
                        value={vendorOption?.find(
                          (o) => o.value === formData?.VendorID
                        )}
                        className={` ${errors.VendorID ? "is-invalid" : ""}`}
                        options={[
                          { value: null, label: "Select" },
                          ...vendorOption,
                        ]}
                      />
                    </div>
                    <div className="col-md-3">
                      <label class="form-label">Invoice No.</label>

                      <Select
                        name="InvoiceNumber"
                        onChange={(selectedOption, action) =>
                          handleInvoiceSelect(selectedOption, action.name)
                        }
                        value={invoiceNumberOption?.find(
                          (o) => o.value === formData?.InvoiceNumber
                        )}
                        className={` ${
                          errors.InvoiceNumber ? "is-invalid" : ""
                        }`}
                        options={[
                          { value: null, label: "Select" },
                          ...invoiceNumberOption,
                        ]}
                      />
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-md-3">
                      <label className="form-label">
                        Price<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text "
                        name="AssetPrice"
                        value={formData?.AssetPrice}
                        className={` form-control ${
                          errors.AssetPrice ? "is-invalid" : ""
                        }`}
                        onChange={(e) => handleChange(e)}
                      />{" "}
                      {errors.AssetPrice && (
                        <div className="invalid-feedback">
                          {errors.AssetPrice}
                        </div>
                      )}
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Service Tag No#</label>
                      <input
                        type="text "
                        name="BatchNo"
                        value={formData?.BatchNo}
                        className="form-control"
                        onChange={(e) => handleChange(e)}
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">
                        Status<span className="text-danger">*</span>
                      </label>
                      <Select
                        name="Allocated"
                        onChange={(selectedOption, action) =>
                          handleSelect(selectedOption, action.name)
                        }
                        value={allocatedOption?.find(
                          (o) => o.value === formData?.Allocated
                        )}
                        options={[
                          { value: null, label: "Select" },
                          ...allocatedOption,
                        ]}
                        className={` ${errors.Allocated ? "is-invalid" : ""}`}
                      />
                      {errors.Allocated && (
                        <div className="invalid-feedback">
                          {errors.Allocated}
                        </div>
                      )}
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Description</label>
                      <textarea
                        name="Description"
                        onChange={(e) => handleChange(e)}
                        className={`form-control`}
                      />
                    </div>
                  </div>
                  <div className="row mt-2">
                    {formData?.AssetType === 0 && (
                      <div className="col-md-3">
                        <label className="form-label">Warranty Date</label>
                        <CustomDatePicker
                          // handleChange={(e) => handleReqDate(e)}
                          handleChange={(e) => handleChange(e)}
                          value={formData.WarrantyDate}
                          name="WarrantyDate"
                          className="form-control"
                          placeholderText="DD-MM-YYYY"
                        />
                      </div>
                    )}

                    {formData?.AssetType === 1 && (
                      <>
                        <div className="col-md-3">
                          <label className="form-label">
                            Subscription Start Date
                          </label>
                          <CustomDatePicker
                            // handleChange={(e) => handleReqDate(e)}
                            handleChange={(e) => handleChange(e)}
                            value={formData.SubscriptionStartDate}
                            name="SubscriptionStartDate"
                            className="form-control"
                            placeholderText="DD-MM-YYYY"
                          />
                        </div>
                        <div className="col-md-3">
                          <label className="form-label">
                            Subscription End Date
                          </label>
                          <CustomDatePicker
                            // handleChange={(e) => handleReqDate(e)}
                            handleChange={(e) => handleChange(e)}
                            value={formData.SubscriptionEndDate}
                            name="SubscriptionEndDate"
                            className="form-control"
                            placeholderText="DD-MM-YYYY"
                          />
                        </div>
                      </>
                    )}
                    {formData?.AssetType === 0 && (
                      <>
                        <div className="col-md-3">
                          <label className="form-label">Storage</label>
                          <input
                            type="text"
                            name="Storage"
                            onChange={(e) => handleChange(e)}
                            className="form-control"
                          />
                        </div>
                        <div className="col-md-3">
                          <label className="form-label">Memory</label>
                          <input
                            type="text"
                            name="Memory"
                            onChange={(e) => handleChange(e)}
                            className="form-control"
                          />
                        </div>
                        <div className="col-md-3">
                          <label className="form-label">Processor</label>
                          <input
                            type="text"
                            name="Processor"
                            onChange={(e) => handleChange(e)}
                            className="form-control"
                          />
                        </div>
                      </>
                    )}
                  </div>

                  {/** Pyment Detials Section */}
                  <div className="row mt-2">
                    <h5 className="fw-bold " style={{ color: "#2E2E48" }}>
                      Payment Details
                    </h5>
                    <hr></hr>
                  </div>
                  <div className="row mt-2">
                    <div className="col-md-3">
                      <lable className="form-label"> Payment Methods</lable>
                      <Select
                        options={paymentOption}
                        name="PaymentMethod"
                        value={paymentOption.find(
                          (o) => o.value === formData?.PaymentMethod
                        )}
                        onChange={(selectedOption, action) =>
                          handleSelect(selectedOption, action.name)
                        }
                      />
                    </div>
                    {formData?.PaymentMethod !== "" &&
                    formData?.PaymentMethod ? (
                      <div className="col-md-3">
                        <lable className="form-label">
                          {" "}
                          {formData?.PaymentMethod === "rtgs"
                            ? "RTGS"
                            : formData?.PaymentMethod === "neft"
                            ? "NEFT"
                            : formData?.PaymentMethod === "chequeno"
                            ? "Cheque"
                            : ""}
                        </lable>
                        <input
                          className="form-control"
                          onChange={(e) => handleChange(e)}
                          name="TransactionNo"
                          value={formData?.TransactionNo}
                        />
                      </div>
                    ) : null}

                    <div className="col-md-3 ">
                      <lable className="form-label">Payment Date</lable>
                      <CustomDatePicker
                        // handleChange={(e) => handleReqDate(e)}
                        handleChange={(e) => handleChange(e)}
                        value={formData?.PaymentDate || null}
                        name="PaymentDate"
                        className="form-control"
                        placeholderText="DD-MM-YYYY"
                      />
                    </div>
                  </div>
                  {/** Pyment Detials Section */}
                  <div className="row mt-2">
                    <div className="d-flex justify-content-end">
                      <div className="d-flex">
                        <div>
                          <button
                            type="button"
                            className="cancel-btn me-2"
                            onClick={() => navigate(`/add-asset`)}
                          >
                            Cancel
                          </button>
                        </div>
                        <div>
                          <button
                            disabled={loading ? true : false}
                            type="submit"
                            className="custom-btn"
                          >
                            {loading ? (
                              <FaSpinner class="sm-spinner" />
                            ) : (
                              "Submit"
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </form>
        </div>
      </>
    );
  }
};

export default AddAssetForm;
